import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconText } from 'components/core/IconText';

import amexLogo from 'assets/images/promos/amexLogo.png';

export default function AmexPromo({ className }) {
	return (
		<IconText
			className={classnames('amex-promo', className)}
			src={amexLogo}
			type="info"
		>
			American Express warmly welcomed
		</IconText>
	);
}

AmexPromo.propTypes = {
	className: PropTypes.string
};
